<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background-color:#fff;margin-bottom:1rem"
      title="销售统计"
    />
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总销售额">
          <template slot="total">
            <a href="#">￥{{ (analysis.money / 100) | NumberFormat }}</a>
          </template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="订单数量">
          <template
            slot="total"
          ><a href="#"><countTo :startVal="0" :endVal="analysis.orders" :duration="3000"></countTo></a
          ></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="新增用户数">
          <template
            slot="total"
          ><a href="#"><countTo :startVal="0" :endVal="analysis.members" :duration="3000"></countTo></a
          ></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="转化率" v-if="analysis.members && analysis.members.visitor_count">
          <template
            slot="total"
          ><a
            href="#"
          ><countTo
            :startVal="0"
            :endVal="(analysis.members * 100) / analysis.baidu.visitor_count"
            :duration="3000"
          ></countTo
          >%</a
          ></template
          >
        </chart-card>
      </a-col>
    </a-row>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background-color:#fff;margin-bottom:1rem"
      title="访问统计"
    />
    <a-row :gutter="24">
      <a-col :sm="24" :md="6" :xl="4" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="浏览量(PV)" v-if="analysis.baidu && analysis.baidu.pv_count">
          <template
            slot="total"
          ><countTo :startVal="0" :endVal="analysis.baidu.pv_count" :duration="3000"></countTo
          ></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="6" :xl="4" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="访客数(UV)" v-if="analysis.baidu && analysis.baidu.visitor_count">
          <template
            slot="total"
          ><countTo :startVal="0" :endVal="analysis.baidu.visitor_count" :duration="3000"></countTo
          ></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="6" :xl="4" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="IP数" v-if="analysis.baidu && analysis.baidu.ip_count">
          <template
            slot="total"
          ><countTo :startVal="0" :endVal="analysis.baidu.ip_count" :duration="3000"></countTo
          ></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="6" :xl="4" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="跳出率" v-if="analysis.baidu && analysis.baidu.bounce_ratio">
          <template
            slot="total"
          ><countTo :startVal="0" :endVal="analysis.baidu.bounce_ratio" :duration="3000"></countTo
          >%</template
          >
        </chart-card>
      </a-col>
      <a-col
        :sm="24"
        :md="6"
        :xl="4"
        :style="{ marginBottom: '24px' }"
        v-if="analysis.baidu && analysis.baidu.avg_visit_time"
      >
        <chart-card
          :loading="loading"
          title="平均访问时长"
          :total="analysis.baidu.avg_visit_time | formatSeconds"
        ></chart-card>
      </a-col>
    </a-row>

    <a-card title="考试预警">
      <a-table :pagination="false" :rowKey="record => record.id" :columns="columns" :data-source="warning">
        <template
          slot="total"
          slot-scope="value"
        ><countTo
          :startVal="0"
          :endVal="value"
          :duration="3000"
          style="color:red;font-size:1.25rem"
        ></countTo
        ></template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import { ChartCard } from '@/components'
import { requestGet } from '@/api/api'

const columns = [
    {
        title: '证书名称',
        dataIndex: 'certificate.title'
    },
    {
        title: '考试模式',
        dataIndex: 'mode.name'
    },
    {
        title: '剩余数量',
        dataIndex: 'total',
        align: 'center',
        scopedSlots: { customRender: 'total' }
    },
    {
        title: '过期时间',
        dataIndex: 'expire_date',
        align: 'center'
    }
]
export default {
    name: 'Analysis',
    components: {
        ChartCard,
        countTo
    },
    data () {
        return {
            columns,
            loading: false,
            analysis: {},
            wloading: false,
            warning: []
        }
    },
    mounted () {
        this.getAnalysis()
        this.getCodyWarning()
    },
    methods: {
        /**
         * 获取考试预警
         * @jdy
         * @2020
         */
        getAnalysis () {
            this.loading = !this.loading
            requestGet('/analysis/today')
                .then(res => {
                    this.analysis = res.result
                })
                .catch(err => {
                    this.$notification.error(err.message)
                })
                .finally(() => {
                    this.loading = !this.loading
                })
        },
        /**
         * 获取考试预警
         * @jdy
         * @2021-1-14
         */
        getCodyWarning () {
            this.wloading = !this.wloading
            requestGet('/certificates/codes/warning')
                .then(res => {
                    this.warning = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
                .finally(() => {
                    this.wloading = !this.wloading
                })
        }
    }
}
</script>

<style lang="less" scoped>
.extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
        display: inline-block;
        margin-right: 24px;

        a {
            margin-left: 24px;
        }
    }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;
}

.antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(100% - 24px);
    /deep/ .ant-card-head {
        position: relative;
    }
}

.dashboard-analysis-iconGroup {
    i {
        margin-left: 16px;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        transition: color 0.32s;
        color: black;
    }
}
.analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
}
/deep/.chart-card-content {
    height: auto;
}
/deep/.chart-card-footer {
    border: none;
    padding: 0;
    margin: 0;
}
</style>
